<template>
  <div>
    <TwoPlus :gids="gids" :url="url" cur-class="choose_one" />
  </div>
</template>

<script>
import TwoPlus from '@/views/config/activity-auxiliary/twoPlus.vue'
export default {
  name: 'ChooseOne',
  components: {
    TwoPlus
  },
  data() {
    return {
      gids: [{ gid: 90010, gtype: 108 }, { gid: 90011, gtype: 108 }],
      url: '/config/activity-auxiliary/chooseOne'
    }
  }
}
</script>

<style scoped>

</style>
